import { create } from 'zustand';

/**
 * Theme store — dark mode default.
 * Reads from localStorage on init, writes on toggle.
 */

function getInitialTheme() {
  if (typeof window === 'undefined') return 'dark';
  const stored = localStorage.getItem('botview-theme');
  if (stored === 'light' || stored === 'dark') return stored;
  return 'dark'; // default
}

function applyThemeToDOM(theme) {
  const root = document.documentElement;
  if (theme === 'dark') {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
}

const useThemeStore = create((set, get) => ({
  theme: getInitialTheme(),

  init: () => {
    const theme = get().theme;
    applyThemeToDOM(theme);
  },

  toggleTheme: () => {
    const next = get().theme === 'dark' ? 'light' : 'dark';
    localStorage.setItem('botview-theme', next);
    applyThemeToDOM(next);
    set({ theme: next });
  },

  setTheme: (theme) => {
    localStorage.setItem('botview-theme', theme);
    applyThemeToDOM(theme);
    set({ theme });
  },
}));

export default useThemeStore;
